import * as THREE from 'three';
import {PCFSoftShadowMap, LoadingManager, Group, PerspectiveCamera, Scene, Color, 
	WebGL1Renderer, sRGBEncoding, WebGLRenderer, AmbientLight, DirectionalLight, Vector3, SpotLight, 
	  UnsignedByteType, PMREMGenerator, Box3} from "three";

import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import {RGBELoader} from 'three/examples/jsm/loaders/RGBELoader.js';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
var defaultOptions = {
	lights: [{
	  name: 'spotLight',
	  type: 'SpotLight'
	}],
	renderer: {
	  shadowMap: {
		enabled: true,
		type: PCFSoftShadowMap
	  }
	},
	controls: {
	  enableZoom: true,
	  enablePan: true
	}
  };
  
  var JolaViewer = /*#__PURE__*/function () {
	function JolaViewer(containerID, options) {
	  if (options === void 0) {
		options = null;
	  }
  
	  this.container = document.getElementById(containerID);
	  var loadingManager = new LoadingManager(function () {
		var loadingScreen = document.getElementById('loading-screen');
		if(loadingScreen?.classList){
		loadingScreen.classList.add('fade-out');
		}
	  });
	  this.loader = new GLTFLoader(loadingManager);
	  this.model = new Group();
	  this.model.name = 'Model';
	  this.options = options || defaultOptions;
	  this.createScene();
	  this.scene.add(this.model);
	  this.createRenderer();
	  this.createCamera();
	  this.createControls();
	  this.createLights();
	  this.update = this.update.bind(this);
	  requestAnimationFrame(this.update);
	  window.addEventListener('resize', this.resize.bind(this), false);
	}
  
	var _proto = JolaViewer.prototype;
  
	_proto.createCamera = function createCamera() {
	  var _this$options$camera, _this$options$camera2, _this$options$camera3;
  
	  this.camera = new PerspectiveCamera(((_this$options$camera = this.options.camera) === null || _this$options$camera === void 0 ? void 0 : _this$options$camera.fov) || 45, this.w / this.h, ((_this$options$camera2 = this.options.camera) === null || _this$options$camera2 === void 0 ? void 0 : _this$options$camera2.near) || 0.1, ((_this$options$camera3 = this.options.camera) === null || _this$options$camera3 === void 0 ? void 0 : _this$options$camera3.far) || 500);
	  this.scene.add(this.camera);
	};
  
	_proto.createScene = function createScene() {
	  this.scene = new Scene();
	  this.scene.background = new Color('white');
	};
  
	_proto.createRenderer = function createRenderer() {
	  var _this$options$rendere, _this$options$rendere2, _this$options$rendere3, _this$options$rendere4;
  
	  this.renderer = new WebGLRenderer({
		antialias: true
	  });
	  this.renderer.setPixelRatio(window.devicePixelRatio);
	  this.w = this.container.clientWidth || 800;
	  this.h = this.container.clientHeight || 800;
	  this.renderer.setSize(this.w, this.h);
	  this.container.appendChild(this.renderer.domElement);
	  this.renderer.outputEncoding = sRGBEncoding;
	  this.renderer.gammaFactor = 2.2;
	  this.renderer.shadowMap.enabled = ((_this$options$rendere = this.options.renderer) === null || _this$options$rendere === void 0 ? void 0 : (_this$options$rendere2 = _this$options$rendere.shadowMap) === null || _this$options$rendere2 === void 0 ? void 0 : _this$options$rendere2.enabled) || true;
	  this.renderer.shadowMap.type = ((_this$options$rendere3 = this.options.renderer) === null || _this$options$rendere3 === void 0 ? void 0 : (_this$options$rendere4 = _this$options$rendere3.shadowMap) === null || _this$options$rendere4 === void 0 ? void 0 : _this$options$rendere4.type) || PCFSoftShadowMap;
	};
  
	_proto.createLights = function createLights() {
	  var _this = this;
  
	  if (!this.options.lights) return;
	  this.options.lights.forEach(function (light) {
		switch (light.type) {
		  case 'AmbientLight':
			var ambientLight = new AmbientLight(light.color || new Color(22, 22, 22), light.intensity || 1);
			ambientLight.name = light.name || '';
  
			_this.scene.add(ambientLight);
  
			break;
  
		  case 'DirectionalLight':
			var directionalLight = new DirectionalLight(light.color || 'white', light.intensity || 1);
			directionalLight.name = light.name || '';
			directionalLight.castShadow = light.shadow || false;
  
			if (directionalLight.castShadow) {
			  var _light$shadow, _light$shadow2, _light$shadow3;
  
			  directionalLight.shadow.bias = ((_light$shadow = light.shadow) === null || _light$shadow === void 0 ? void 0 : _light$shadow.bias) || 0;
			  directionalLight.shadow.normalBias = ((_light$shadow2 = light.shadow) === null || _light$shadow2 === void 0 ? void 0 : _light$shadow2.normalBias) || 0;
			  directionalLight.shadow.radius = ((_light$shadow3 = light.shadow) === null || _light$shadow3 === void 0 ? void 0 : _light$shadow3.radius) || 1;
			}
  
			if (light.parent) {
			  switch (light.parent) {
				case 'camera':
				  _this.camera.add(directionalLight);
  
				  break;
  
				case 'scene':
				  _this.scene.add(directionalLight);
  
				  break;
			  }
			} else {
			  _this.scene.add(directionalLight);
			}
  
			directionalLight.position.copy(light.position || new Vector3(5, 10, 7.5));
			break;
  
		  case 'SpotLight':
			var spotLight = new SpotLight(light.color || 'white', light.intensity || 1, light.distance || 0, light.angle || 0.314, light.penumbra || 0, light.decay || 1);
			spotLight.name = light.name || '';
			spotLight.castShadow = light.shadow || false;
  
			if (spotLight.castShadow) {
			  var _light$shadow4, _light$shadow5, _light$shadow6, _light$shadow7, _light$shadow7$mapSiz, _light$shadow8, _light$shadow8$mapSiz;
  
			  spotLight.shadow.bias = ((_light$shadow4 = light.shadow) === null || _light$shadow4 === void 0 ? void 0 : _light$shadow4.bias) || 0;
			  spotLight.shadow.normalBias = ((_light$shadow5 = light.shadow) === null || _light$shadow5 === void 0 ? void 0 : _light$shadow5.normalBias) || 0;
			  spotLight.shadow.radius = ((_light$shadow6 = light.shadow) === null || _light$shadow6 === void 0 ? void 0 : _light$shadow6.radius) || 1;
			  spotLight.shadow.mapSize.width = ((_light$shadow7 = light.shadow) === null || _light$shadow7 === void 0 ? void 0 : (_light$shadow7$mapSiz = _light$shadow7.mapSize) === null || _light$shadow7$mapSiz === void 0 ? void 0 : _light$shadow7$mapSiz.width) || 512;
			  spotLight.shadow.mapSize.height = ((_light$shadow8 = light.shadow) === null || _light$shadow8 === void 0 ? void 0 : (_light$shadow8$mapSiz = _light$shadow8.mapSize) === null || _light$shadow8$mapSiz === void 0 ? void 0 : _light$shadow8$mapSiz.height) || 512;
			}
  
			if (light.parent) {
			  switch (light.parent) {
				case 'camera':
				  _this.camera.add(spotLight);
  
				  break;
  
				case 'scene':
				  _this.scene.add(spotLight);
  
				  break;
			  }
			} else {
			  _this.scene.add(spotLight);
			}
  
			spotLight.position.copy(light.position || new Vector3(5, 10, 7.5));
		}
	  });
	};
  
	_proto.createControls = function createControls() {
	  var _this$options, _this$options$control, _this$options2, _this$options2$contro;
  
	  this.controls = new OrbitControls(this.camera, this.renderer.domElement);
	  this.controls.enableDamping = true;
	  this.controls.dampingFactor = 0.05;
	  this.controls.enablePan = (_this$options = this.options) === null || _this$options === void 0 ? void 0 : (_this$options$control = _this$options.controls) === null || _this$options$control === void 0 ? void 0 : _this$options$control.enablePan;
	  this.controls.enableZoom = (_this$options2 = this.options) === null || _this$options2 === void 0 ? void 0 : (_this$options2$contro = _this$options2.controls) === null || _this$options2$contro === void 0 ? void 0 : _this$options2$contro.enableZoom;
	  this.controls.enableKeys = false;
	  this.controls.minDistance = 0;
	  this.controls.maxDistance = 500;
	  this.controls.minPolarAngle = 1;
	  this.controls.maxPolarAngle = Math.PI / 2;
	};
  
	_proto.setSize = function setSize(width, height) {
	  this.w = width;
	  this.h = height;
	  this.camera.aspect = this.w / this.h;
	  this.camera.updateProjectionMatrix();
	  this.renderer.setSize(this.w, this.h);
	};
  
	_proto.loadHDR = function loadHDR(hdrPath, hdrIntensity) {
	  var _this2 = this;
  
	  if (hdrIntensity === void 0) {
		hdrIntensity = 1;
	  }
  
	  this.envMapIntensity = hdrIntensity;
	  var rgbLoader = new RGBELoader();
	  rgbLoader.setDataType(UnsignedByteType).load(hdrPath, function (texture) {
		_this2.pmremGenerator = new PMREMGenerator(_this2.renderer);
  
		_this2.pmremGenerator.compileEquirectangularShader();
  
		_this2.envMap = _this2.pmremGenerator.fromEquirectangular(texture).texture;
  
		_this2.updateEnvMap();
	  });
	};
  
	_proto.resize = function resize() {
	  var _this$container = this.container,
		  clientHeight = _this$container.clientHeight,
		  clientWidth = _this$container.clientWidth;
	  this.setSize(clientWidth, clientHeight);
	};
  
	_proto.updateEnvMap = function updateEnvMap() {
	  var _this3 = this;
  
	  this.model.traverse(function (child) {
		if (child.isMesh) {
		  child.material.envMap = _this3.envMap;
		  child.material.envMapIntensity = _this3.envMapIntensity;
		  child.material.needsUpdate = true;
		}
	  });
	};
  
	_proto.updateCameraPosition = function updateCameraPosition() {
	  var boundingBox = new Box3().setFromObject(this.model);
	  var boundingSize = boundingBox.getSize(new Vector3()).length();
	  var boundingCenter = boundingBox.getCenter(new Vector3());
	  this.camera.position.copy(boundingCenter);
	  this.camera.position.x += boundingSize;
	  this.camera.position.y += boundingSize;
	  this.camera.position.z += boundingSize;
	  this.controls.target = boundingCenter;
	};
  
	_proto.update = function update() {
	  requestAnimationFrame(this.update);
	  this.controls.update();
	  this.renderer.render(this.scene, this.camera);
	};
  
	return JolaViewer;
  }();
  
  export default JolaViewer;
  //# sourceMappingURL=index.js.map
  